"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textProposal = void 0;
var ow_1 = __importDefault(require("ow"));
var codec_1 = require("../../../../cosmos/v1beta1/codec");
var ow_types_1 = require("../ow.types");
var typeurl_1 = require("../../../common/constants/typeurl");
exports.textProposal = function () {
    return (function () {
        function TextProposal(options) {
            ow_1.default(options, 'options', ow_types_1.owTextProposalOptions);
            this.title = options.title;
            this.description = options.description;
        }
        TextProposal.prototype.getEncoded = function () {
            var textProposalOptions = {
                title: this.title,
                description: this.description,
            };
            var textProposalProto = codec_1.cosmos.gov.v1beta1.TextProposal.create(textProposalOptions);
            return codec_1.google.protobuf.Any.create({
                type_url: typeurl_1.COSMOS_MSG_TYPEURL.gov.TextProposal,
                value: codec_1.cosmos.gov.v1beta1.TextProposal.encode(textProposalProto).finish(),
            });
        };
        return TextProposal;
    }());
};
//# sourceMappingURL=TextProposal.js.map